const BAPLIE_FILE_SOURCES = {
  MOBILE: 'MOBILE',
  WEB: 'WEB',
}

export default BAPLIE_FILE_SOURCES
